var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSquareArrowUp = function SvgSquareArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "currentColor"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 12,
    height: 12,
    rx: 4,
    transform: "rotate(-180 12 12)",
    fill: "#7E7ED6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.638 6.988L6 4.35 3.363 6.988",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSquareArrowUp;